<template>
  <v-container id="sobre" fluid class="grey lighten-3 py-0 px-0">
    <v-row >
      <v-col cols="12" md="6" class="py-0 my-0">
        <v-img
          :src="getImgUrl(imagem)"
          class="center"
          justify="center"
          contain
        />
      </v-col>
      <v-col 
        cols="12" md="6" 
        class="px-11 pt-12 mb-10"
      >
        <v-card
          flat
          color="transparent"
          :class="{
            'pr-10': $vuetify.breakpoint.mdAndUp
          }"
        >
          <!-- <v-card-text>{{ text }}</v-card-text> -->
          <h3 class="body-1 font-weight-regular pt-3">
            <span class="poppins primary--text">sobre o instrutor</span>
          </h3>
          <h2 class="display-1 font-weight-bold pt-2 transparent">
            <span class="barlow" v-text="titulo"></span>
          </h2>
          <v-divider class="primary my-4" style="width: 50px; border: 2px solid"></v-divider>
          <h3 class="headline pb-2">
            <span class="barlow" v-html="subtitulo"></span>
          </h3> 
          <div class="pt-3 grey--text text--darken-1 font-weight-light">
            <span class="poppins" v-html="descricao" style="line-height: 1.5"></span>
          </div>
          <div class="pt-3 headline black--text font-weight-medium font-italic">
            <span class="barlow">"Sou apaixonado pelo SER HUMANO e acredito verdadeiramente no poder que cada um traz dentro de si de encontrar sua melhor versão. Somos construtores de nosso destino e a cada manhã somos convidados a viver o nosso melhor."</span>
          </div>
          <div class="pt-2 body-1 primary--text font-weight-light">
            <span class="poppins">- Tadeu Belfort Jr</span>
          </div>
        </v-card>
        <div
          class="justify-center align-center center pt-8 pb-6"
        >
          <v-btn
            v-for="(b,i) in acoes" :key="i"
            x-large :outlined="!b.destaque"
            :color="b.cor"
            class="mr-5 mb-3"
            :class="{
              'title': $vuetify.breakpoint.mdAndUp,
            }"
            target="_blank"
            @click="$vuetify.goTo(b.click)"
          >
            <span class="">{{b.rotulo}}</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    imagem: 'sobre.jpg',
    titulo: 'TADEU BELFORT JR',
    subtitulo: 'É facilitador de grupos e treinador comportamental há mais de 20 anos. Criador do Treinamento Vivencial Luz e Sombra.',
    descricao: '<p>\n\
        <b class="primary--text">Qualificação</b>\n\
      </p>\n\
      <p>\n\
        Professor de Pós-graduação, Psicanalista Clínico, Terapeuta Sistêmico, Terapeuta Integrativo, Terapeuta Transgeracional, Trainer em PNL e Neurossemântica certificado   pela  International Socyety of Neuro-Semantics - ISNS e  Master Trainer em Psicologia Positiva certificado  pela  European Positive Psychology Academy - EUPPA. Administrador de Empresas, Teólogo e Filósofo com especialização em Psicologia da Religião, Psicologia Junguiana, Psicologia Positiva e Gestão de Pessoas. Mestre e Doutor em Hipnose Clínica.\n\
      </p>\n\
      <p>\n\
        <b class="primary--text">Membro</b><br>\n\
      </p>\n\
      <p>\n\
        <ul>\n\
         <li>International Society of Neuro-semantics - ISNS</li>\n\
         <li>International Association for Generative Change - IACG</li>\n\
         <li>The International  Business Coaching Institute - IBCI</li>\n\
         <li>European Positive Psychology Academy - EUPPA</li>\n\
         <li>Associação da Psicologia Positiva da América Latina - APPAL</li>\n\
        </ul>\n\
      </p>\n\
      <p>\n\
        <b class="primary--text">Livros em Co-Autoria</b>\n\
      </p>\n\
      <p>\n\
        <ul>\n\
         <li>Por que Sou Coaching? - Editora IBC</li>\n\
         <li>Sem Limites - Editora IBC</li>\n\
         <li>Treinamentos de Alto Impacto - Editora Ser Mais</li>\n\
         <li>O Fim da Era Chefe - Editora Ser Mais</li>\n\
        </ul>\n\
      </p>',
    acoes: [
      {
        rotulo: 'VER DEPOIMENTOS',
        cor: 'black',
        destaque: false,
        link: '',
        click: '#depoimentos'
      },
    ] 
  }),
  methods: {
    getImgUrl(i) {
        return require('../assets/img/'+i)
    },
  }
};
</script>